module.exports = __webpack_public_path__ + "static/Adieu-Light-b349a74c463aa7f4054db52665dcf4a8.woff";